<template>
  <div id="container">
    <app-header :pathArray="pathArray"/>
    <div class="wrapper">
        <div class="page-container">
          <side-bar v-if="sideBarShow"/>
          <div class="one-farm" style="overflow-y: auto;">
            <router-view />
          </div>
        </div>
    </div>
    <!-- <app-footer /> -->
  </div>
</template>

<script>
import AppHeader from '@/components/header'
import { getBelong } from "@/utils/api.js";
// import AppFooter from '@/components/footer/index.vue'
import SideBar from '@/components/sidebar'
export default {
  name: 'layoutMain',
  data(){
    return{
      pathArray:[],
      sideBarShow:null
    }
  },
  components: {
    AppHeader,
    // AppFooter,
    SideBar
  },
  watch:{
      $route(to,from){
        if(to.path.indexOf('admin') > -1){
          this.sideBarShow = false
        }else{
          this.sideBarShow = true
        }
        let pathArray = []
        pathArray.push(to.path)
        this.pathArray = pathArray
        this.collapseNavbar()
      }
  },
  methods: {
    //移动端菜单选中跳转后自动缩回,与open断点一致(<992)
    collapseNavbar() {
      if ($(window).width() < 992 && $('.navbar-toggle').hasClass('open')) {
        $('.navbar-toggle').removeClass('open');
        $('#navigation').slideUp(400);
        $('li.has-submenu.open, .submenu.open').removeClass('open');
      }
    },
    initNavbar() {
      $('.navbar-toggle').on('click', function (event) {
        $(this).toggleClass('open');
        $('#navigation').slideToggle(400);
      });

      $('.navigation-menu li.has-submenu a').on('click', function (e) {
        if ($(window).width() < 992) {
          e.preventDefault();
          $(this).parent('li').toggleClass('open').find('.submenu:first').toggleClass('open');
        }
      });
    },
    // initScrollbar() {
    //   $('.slimscroll').slimscroll({
    //     height: 'auto',
    //     position: 'right',
    //     size: "8px",
    //     color: '#9ea5ab'
    //   });
    // }
  },
  mounted() {
    let path = this.$route.path
    if(path.indexOf('admin') > -1){
      this.sideBarShow = false
    }else{
      this.sideBarShow = true
    }
    this.pathArray.push(path)
    this.$nextTick(()=>{
      this.initNavbar();
      // this.initScrollbar();
    })

  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue